export default "__VITE_ASSET__CPjov0Oj__"